import React, { useEffect, useState } from "react";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function RequireAuth({ children }) {
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        alert("You must log in.");
        navigate("/admin/login");
        setChecking(false);
        return;
      }

      // 🔥 Fetch real custom claims (super important)
      const tokenResult = await user.getIdTokenResult(true);

      console.log("🔥 TOKEN CLAIMS:", tokenResult.claims);

      if (!tokenResult.claims.admin) {
        alert("You are not an admin!");
        navigate("/admin/login");
      }

      setChecking(false);
    });

    return () => unsub();
  }, [navigate]);

  if (checking) {
    return (
      <div className="w-full h-screen flex items-center justify-center text-white">
        Checking admin access…
      </div>
    );
  }

  return children;
}
